import { createMiddleware } from "@tanstack/react-start";

import { setServerFnLogContext } from "#/lib/requestLogger.server";

export const serverFnLogMiddleware = createMiddleware({ type: "function" }).server(
  async ({ next, serverFnMeta }) => {
    try {
      setServerFnLogContext(serverFnMeta);
    } catch {}
    return next();
  },
);
